import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Popper from '@mui/material/Popper';
import React, { useRef, useState } from 'react';

import { useIsWidthUp } from '../utils';
import { getCodeEditorValue } from './CodeEditor';
import SandboxedHtmlPreview from './SandboxedHtmlPreview';

const HtmlPopper = ({ htmlContent, cm }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const isSmallScreen = !useIsWidthUp('sm');

    const handleClick = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClickAway = () => {
        setOpen(false);
    };

    return (
        <>
            {htmlContent && (
                <Button ref={anchorRef} variant="contained" onClick={handleClick}>
                    HTML preview
                </Button>
            )}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement={isSmallScreen ? 'auto' : 'right'}
                sx={{ zIndex: 1000000 }}
                style={{ backgroundColor: 'white', border: 'solid 1px #d8d8d8', maxWidth: isSmallScreen ? 'calc(100vw - 1rem)' : '500px', minWidth: '250px', minHeight: '200px', overflow: 'auto' }}
            >
                <ClickAwayListener onClickAway={handleClickAway}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#F5F5F5', padding: '1rem' }}>
                            <Typography>HTML Preview</Typography>
                            <div>
                                <CloseIcon onClick={handleClickAway} sx={{ cursor: 'pointer' }} />
                            </div>
                        </div>
                        <SandboxedHtmlPreview
                            html={getCodeEditorValue(cm)}
                            title="HTML preview"
                            style={{
                                border: 'none',
                                width: isSmallScreen ? 'calc(100vw - 1rem)' : '500px',
                                height: isSmallScreen ? 'calc(100vh - 10rem)' : 'calc(100vh - 25rem)',
                                minHeight: '200px',
                            }}
                        />
                    </div>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default HtmlPopper;
